import React from "react";
import '../Styles/Main.css';

export default function Checkout() {
  return (
    <div className="checkout">
      checkout
    </div>
)
}

